import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./partnersCarousel.css";
import { partners } from "../../assets/data/data";
import UseFetch from "../hooks/UseFetch";
import { Link } from "react-router-dom";
const PartnersCarousel = () => {
  // Partners array

  const [isMobile, setIsMobile] = useState(false);
  const { data, loading } = UseFetch("partners", {
    method: "get",
    details: {},
  });
  // Check for screen size and update state
  // console.log(data);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768); // Set 768px as mobile breakpoint
    };
    // Check initial screen size
    checkScreenSize();

    // Add event listener for window resize
    window.addEventListener("resize", checkScreenSize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  // Responsive breakpoints
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      slidesToSlide: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  return (
    <div className="container justify-content-between">
      <Carousel
        swipeable={true}
        draggable={false}
        showDots={false}
        responsive={responsive}
        ssr={true} // Render carousel on server-side
        infinite={true}
        autoPlay={true} // Set to `true` for auto-play
        autoPlaySpeed={5000}
        keyBoardControl={false}
        customTransition="all .5"
        transitionDuration={500}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-10-px"
        centerMode={!isMobile}
        rewindWithAnimation={true}
      >
        {data
          ? data?.map((partner) => (
              <div key={partner.id}>
                {/* <img
              src={partner.logo}
              alt={partner.name}
              className="d-block w-50"
            />
            <span>{partner.name}</span> */}
                <div className="partner">
                  <div className="partner-header d-flex align-items-center">
                    <div className="partner-img me-4">
                      <img
                        src={process.env.REACT_APP_UPLOADS_URL + partner.photo}
                        alt={partner.name}
                      />
                    </div>
                    <div className="partner-info">
                      <span className="fs-6 name">{partner.name}</span>
                      <li>
                        <a
                          href={partner.website}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="theme-clr me-1 fas fa-globe"></i>
                          {partner.website}
                        </a>
                      </li>
                    </div>
                  </div>
                </div>
              </div>
            ))
          : loading}
      </Carousel>
    </div>
  );
};

export default PartnersCarousel;
